module.exports = __webpack_public_path__ + "img/stomp-paris.d20f7d3f.jpg";